export const generators = [
  {
    id: "reword",
    title: "Level up your content and find new ideas",
    path: "/reword-it",
    env: ["development", "production"],
    preview: {
      image:
        "https://emoji.aranja.com/static/emoji-data/img-apple-160/1f5e3-fe0f.png",
      title: "Reword It",
      content: "Improve your writing or find new ways to word things",
      tags: ["Great Grammer", "Different Tones"],
    },
    topic: {
      label: "What do you want to reword?",
      placeholder: "Paste the content you would like to reword.",
      minCharacters: 35,
    },
    select: {
      label: "Tone",
      options: [
        {
          label: "😎 Friendly",
          value: "friendly",
        },
        {
          label: "😌 Relaxed",
          value: "relaxed",
        },
        {
          label: "💪 Bold",
          value: "bold",
        },
        {
          label: "💡 Witty",
          value: "witty",
        },
        {
          label: "🧠 Persuasive",
          value: "persuasive",
        },
        {
          label: "🥼 Professional",
          value: "professional",
        },
      ],
    },
    api: "/reword",
    buttonLabel: "Reword",
  },
  {
    id: "lesson-plans",
    title: "Generate new ideas for lesson plans",
    path: "/create-lesson-plans",
    env: ["development", "production"],
    preview: {
      image:
        "https://emoji.aranja.com/static/emoji-data/img-apple-160/1f4da.png",
      title: "Lesson Plans",
      content: "Creative lesson plans your students will love",
      tags: ["Labs", "Classroom Simulations"],
    },
    topic: {
      label: "What is the focus of the lesson plan?",
      placeholder:
        "Patient simulation lab activity for occupational therapy students with a focus on hearing impairment and performance of activities of daily living.",
      helperItems: [
        "Provide more details about what you want to accomplish",
        "Provide more information what topic the lesson plan is for",
        "Use 35 words or more",
      ],
      minCharacters: 35,
    },
    api: "/learning-activities",
    buttonLabel: "Generate Lesson Plan",
  },
  {
    id: "resume",
    title: "Generate dynamic Resume bullet points",
    path: "/create-resume-content",
    env: ["development", "production"],
    preview: {
      image:
        "https://emoji.aranja.com/static/emoji-data/img-apple-160/1f4bc.png",
      title: "Resume",
      content: "Generate action-oriented bullet points for your Resume",
      tags: ["Impact Driven", "Uses Active Voice"],
    },
    topic: {
      label: "What did you do?",
      placeholder: "I managed 4 students for their internship",
      helperItems: [
        "Be more specific about what you do",
        "Use 30 words or more",
      ],
      minCharacters: 30,
    },
    secondTopic: {
      label: "What was your job title?",
      placeholder: "Legal Assistant",
      helperItems: ["Specify what the company you work for does"],
    },
    api: "/resume",
    buttonLabel: "Generate Resume Points",
  },
  {
    id: "letter-of-recommendation",
    title: "Write a personalized recommendation",
    path: "/create-letter-of-recommendation",
    env: ["development", "production"],
    preview: {
      image:
        "https://emoji.aranja.com/static/emoji-data/img-apple-160/1f4ee.png",
      title: "Recommendation",
      content: "Write a personalized Letter of Recommendation",
      tags: ["Personalized", "Custom"],
    },
    topic: {
      label: "Who is this for?",
      placeholder:
        "Write a couple points about the person and what you are recommending them for",
      helperItems: [
        "Provide more details about the person",
        "Provide more information about what you are recommending them for",
        "Use 35 words or more",
      ],
      minCharacters: 35,
    },
    api: "/letter-of-recommendation",
    buttonLabel: "Create Letter of Recommendation",
  },
  {
    id: "depth-of-knowledge",
    title: "Create new Quiz Questions in seconds",
    path: "/create-quiz-questions",
    env: ["development", "production"],
    preview: {
      image:
        "https://emoji.aranja.com/static/emoji-data/img-apple-160/1f4dd.png",
      title: "Quiz Questions",
      content: "Generate quiz questions based on a topic",
      tags: ["Multiple Choice", "Free Response", "T/F"],
    },
    topic: {
      label: "What topic are you generating questions for?",
      placeholder: "The American Revolution for a Sixth grade class",
      helperItems: [
        "Provide more details",
        "Use 30 words or more",
        "Specify grade level for questions",
      ],
      minCharacters: 30,
    },
    select: {
      label: "Specify Depth of Knowledge",
      options: [
        {
          label: "Mixed 😎",
          value: "mixed",
        },
        {
          label: "🗣️ Remember - Recall facts and basic concepts",
          value: "remember",
        },
        {
          label: "✍️ Understand - Explain ideas or concepts",
          value: "understand",
        },
        {
          label: "🤔 Apply - Use information in new situations",
          value: "apply",
        },
        {
          label: "🤯 Analyze - Justify a stand or decision",
          value: "analyze",
        },
      ],
      popoverTitle: "What is Depth of Knowledge",
      popoverBody:
        "Depth of Knowledge refers to the level of critical thinking and analysis applied to a particular task or problem. It can range from a surface-level understanding, where one simply remembers or repeats information, to a deeper level of understanding and analysis, where one is able to make connections, see relationships and draw conclusions.",
    },
    secondSelect: {
      label: "Question Format",
      options: [
        {
          label: "Free Response",
          value: "free_response",
        },
        // {
        //     label: "Multiple Choice",
        //     value: "multiple_choice",
        // },
        // {
        //     label: "True / False",
        //     value: "true_false",
        // },
      ],
    },
    api: "/questions",
    buttonLabel: "Generate Questions",
  },
  {
    id: "email",
    title: "Write a professional email in seconds",
    path: "/write-an-email",
    env: ["development", "production"],
    preview: {
      image:
        "https://emoji.aranja.com/static/emoji-data/img-apple-160/2709-fe0f.png",
      title: "Email",
      content: "Take a couple points and write a professional email ",
      tags: ["Professional", "Concise"],
    },
    topic: {
      label: "What is it about?",
      placeholder: "Give some context or points to mention in the email.",
      helperItems: [
        "Provide more details about what you want to accomplish",
        "Provide more information what and who the email is for",
        "Use 35 words or more",
      ],
      minCharacters: 35,
    },
    api: "/email",
    buttonLabel: "Write the email",
  },
  {
    id: "essay-outline",
    title: "Generate an outline on your favorite topic",
    path: "/create-essay-outline",
    env: ["development", "production"],
    preview: {
      image:
        "https://emoji.aranja.com/static/emoji-data/img-apple-160/1f4c4.png",
      title: "Essay Outline",
      content: "Create a detailed essay outline on your favorite topic",
      tags: ["Brainstorming", "Detailed Outline"],
    },
    topic: {
      label: "What topic?",
      placeholder: "The Third Amendment",
      minCharacters: 5,
    },
    api: "/essay-outline",
    buttonLabel: "Create Essay Outline",
  },
];

export const chats = [
  {
    id: "playground",
    title: "Ask Robin",
    path: "/robin",
    env: ["development", "production"],
    preview: {
      image: "https://cdn-icons-png.flaticon.com/512/2144/2144139.png",
      title: "Ask Robin",
      content: "Chat with your sidekick! Every Batman has a Robin!",
      tags: ["Sandbox", "Ask Anything", "Chat"],
    },
    api: "/playground",
  },
];
